import "./App.css";
import "./Pages/Page.css";
import Auth0Context from "./context/Auth0Context";
import AxiosContext from "./context/AxiosContext";
import ModalContext from "./context/ModalContext";
import useDarkModeOn from "./hooks/useDarkModeOn";
import useOnlineStatus from "./hooks/useOnlineStatus";
import "./styles/component.css";
import "./styles/formElement.css";
import "./styles/root.css";
import "./styles/utilities.css";
import AppShell from "./AppShell";

function App() {
  useOnlineStatus();
  useDarkModeOn();
  return (
    <Auth0Context>
      <AxiosContext>
        <ModalContext>
          <AppShell />
        </ModalContext>
      </AxiosContext>
    </Auth0Context>
  );
}

export default App;
